module.exports = __webpack_public_path__ + "img/direction-arrow-long.22823612.svg";